const sortTiers = (pkg) => [...(pkg?.price_tiers || [])].sort((a, b) => a.pax - b.pax);

export const packageLimits = (pkg) => {
  const tiers = sortTiers(pkg);
  if (tiers.length && !(pkg.extra_pax_price > 0)) {
    return [Math.min(pkg.min_participants, tiers[0].pax), tiers[tiers.length - 1].pax];
  }
  return [pkg.min_participants, pkg.max_participants];
};

export const packageTotal = (pkg, pax) => {
  const [low, high] = packageLimits(pkg);
  if (!pax || pax < low || pax > high) return null;
  const tiers = sortTiers(pkg);
  if (!tiers.length) return pkg.price_per_person * pax;
  const exact = tiers.find((t) => t.pax === pax);
  if (exact) return exact.price;
  const lower = tiers.filter((t) => t.pax < pax);
  if (!lower.length || !(pkg.extra_pax_price > 0)) return null;
  const base = lower[lower.length - 1];
  return base.price + (pax - base.pax) * pkg.extra_pax_price;
};

export const startPrice = (pkg) => {
  const tiers = sortTiers(pkg);
  return tiers.length ? tiers[0].price : pkg.price_per_person;
};

export const tripStartPrice = (trip) => Math.min(...(trip?.packages || []).map(startPrice));

export const tierRows = (pkg) => sortTiers(pkg);
